import { render, staticRenderFns } from "./StoreOwnerFangKuan.vue?vue&type=template&id=223a88fb&scoped=true&"
import script from "./StoreOwnerFangKuan.vue?vue&type=script&lang=js&"
export * from "./StoreOwnerFangKuan.vue?vue&type=script&lang=js&"
import style0 from "./StoreOwnerFangKuan.vue?vue&type=style&index=0&id=223a88fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a88fb",
  null
  
)

export default component.exports